module.exports = __webpack_public_path__ + "static/media/10-4.9ed8cd2c.mp3";